import styled from '@emotion/styled'
import { Menu } from 'antd'
import type { MenuProps } from 'antd'

import { PORTFOLIO_SECTION_IDS } from 'constants/portfolio.constants'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'

type MenuItem = Required<MenuProps>['items'][number]

const {
  TAXES_ID,
  TEMPLATE_ID,
  TRADING_ID,
  STRATEGY_ID,
  CONSTRAINTS_ID,
  FACTOR_TILTS_ID,
  ASSETS_ID,
} = PORTFOLIO_SECTION_IDS

const navigationSectionsAndLabels = [
  { id: TEMPLATE_ID, label: 'Template' },
  { id: TRADING_ID, label: 'Trading' },
  { id: TAXES_ID, label: 'Taxes' },
  { id: STRATEGY_ID, label: 'Strategy' },
  { id: CONSTRAINTS_ID, label: 'Constraints' },
  { id: FACTOR_TILTS_ID, label: 'Factor Tilts' },
  { id: ASSETS_ID, label: 'Assets' },
]

export default function InvestmentPreferenceNavigationSection() {
  const createMenuItem = (id: string, label: string) => {
    return {
      key: id,
      label: (
        <PDSBox
          onClick={() => {
            const element = document.getElementById(id)
            element?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            })
          }}
        >
          {label}
        </PDSBox>
      ),
    }
  }

  const items: MenuItem[] = navigationSectionsAndLabels.map(({ id, label }) =>
    createMenuItem(id, label)
  )
  // Todo: Make custom list and navigation components
  return (
    <PDSBox width="10rem">
      <PDSBox overflowX="hidden" position="sticky" top="2rem">
        <CustomNavigationMenu
          mode="inline"
          items={items}
          defaultSelectedKeys={[TEMPLATE_ID]}
          style={{
            border: 'none',
          }}
        />
      </PDSBox>
    </PDSBox>
  )
}

// Refactor this to not rely on antd
export const CustomNavigationMenu = styled(Menu)`
  background-color: ${COLOR.backdrop};

  .ant-menu-item-selected {
    background-color: ${COLOR.feedbackAction};
    color: ${COLOR.textAction};
    font-weight: ${FONT_WEIGHT.semibold};
  }

  .ant-menu-item:hover {
    background-color: ${COLOR.feedbackAction} !important;
  }
`
